import { formatText } from 'core/i18n';
import React, { useMemo } from 'react';

export const DocumentationButton = ({ documentsList, onClick }) => {
    const documentationButtonText = useMemo(
        () =>
            documentsList?.some(document => document.isAccepted) &&
            documentsList?.some(document => !document.isAccepted)
                ? formatText('button-readRemainingDocuments')
                : formatText('button-readAllDocuments'),
        [documentsList]
    );

    return (
        <div className="documentation-button">
            <button
                type={'button'}
                className="form__button form__button-secondary"
                aria-label="confirm-btn"
                onClick={onClick}
            >
                {documentationButtonText}
            </button>
        </div>
    );
};
